import { styled } from 'styled-components'

export const ButtonContainer = styled.div`
  position: relative;
`

export const ButtonOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  margin: 0;
  cursor: pointer;
  pointer-events: auto;
`
